<template> 
    <template v-if="mode === 'table'">

            <div v-if="modelValue.id">
                <div v-if="this.modelValue.linkid">
<!-- {{ $store.state.mainurl+publicPath+linktospecimen+column.widget.properties.dataset_id+'/'+modelValue.id }} -->
                    <v-btn
                    variant="outlined"
                    :href="$store.state.mainurl+publicPath+linktospecimen+column.widget.properties.dataset_id+'/'+modelValue.id" target="_blank"
                    > {{modelValue.linkid}}
                    </v-btn>
                    <!-- @click="$router.push(column.widget.properties.dataset_id+'/'+modelValue.id)" target="_blank" -->
                </div>
                <div v-else>
                    <div class="text-truncate" style="max-width: 300px;"> {{ modelValue.name }} </div>
                </div>
            </div>
            <div v-else>
                <div></div>
            </div>

    </template>
    <template v-else-if="mode === 'view'">  
        <div v-if="modelValue.id">
            <div v-if="this.modelValue.linkid">
                        <v-btn
                        variant="outlined"
                        @click="$router.push(column.widget.properties.dataset_id+'/'+modelValue.id)" target="_blank"
                        > {{modelValue.linkid}}
                        </v-btn>

                    </div>
                    <div v-else>
                        <div class="text-truncate" style="max-width: 300px;"> {{ modelValue.name }} </div>
                    </div>
                </div>
        <div v-else>
            <div></div>
        </div>
    </template>

    <template v-else-if="mode === 'edit'">
        <v-autocomplete         
            variant="outlined"
            class="mb-1"
                :items="options"
                item-title="title"
                item-value="value" 
                :label="this.column.title"
                v-model:search="search"
            v-model = "searchvalue"
            return-object
            @update:model-value="handleInput()"
        />

<!--сделать проверку на объект - для случаев когда классифай используется для прикрепления таблицы (но пока всегда этот ид таблицы скрывается)-->
    </template>
    <template v-else>
        {{v}}
    </template>
    
</template>

<!-- v-model:search="search" 
 
                :items="options"
                item-title="title"
                item-value="value" -->

<script>
import axios from 'axios';
import {toRaw} from 'vue';

export default {
    name: 'classify-widget',
    props:['mode','column', 'modelValue', 'lengthrow'], // искать отметку в column
    emits: ['update:modelValue'],
    data(){

        return {
            // v: s,
            // vid: ids,
            linktospecimen: '',
            v: '',
            vid: null,
            linkspecimen: '',

            typeMV: '',

            options: [{"value":this.vid, "title":this.v}],
//   searchvalue: {"value":this.modelValue.id, "title":this.modelValue.name},
//    searchvalue: {"value":this.ids, "title":this.s},
   searchvalue: {"value":this.vid, "title":this.v},


            search: this.v,
            labelmessage: "Type more than 3 symbols, please",  

           isobject: false,

           fields: '',
           responseClassify: {},
           publicPath:'',
           groupFilter: '', 
        }
                    
    },

    mounted(){

        this.publicPath = process.env.BASE_URL+'#';
//console.log(this.publicPath, process.env.BASE_URL);

// console.log(this.publicPath);
// if ($store.state.mainurl.includes('https://isling.org')){
//     this.publicPath = '/dist/#';
// }
// else {
//     this.publicPath = '';
// }
        //если\когда морда будет лежать в корне (а не в дисте) - этот участок надо будет переписать (компоненты ClassifyWidget.vue, ObjectviewWidget.vue)

        let path = this.$route.matched[0].path.replace(":idtable", "");
        this.linktospecimen = path;

//                    console.log(path);

        if (this.modelValue != undefined && this.modelValue != '') {

            if (this.column != undefined && this.column.widget != undefined) {
                let props = this.column.widget.properties;
                if (props != undefined && props.db_field != null && props.db_field != undefined){
                    this.fields = props.db_field.join(',');
                    this.fields+=','+props.synonym;
                }
                

                if (typeof this.modelValue =='object') {
                    this.v = '';
                    for(var i =0; i < props.db_field.length; i++) {
                        this.v+=this.modelValue[props.db_field[i]]
                    }
                    this.vid = this.modelValue.id;
                    this.searchvalue = {"value":this.vid, "title": this.v};
                    this.search = this.v;
                    this.options = [{"value":this.vid, "title": this.v}];
                }
                else if (!isNaN(this.modelValue)) {
                            //		let ref_id=this.modelValue; // что это?
                    if (props.another && (this.modelValue == -1 || this.modelValue == '-1')) {
                        return props.another;
                    }
                    if (props.db_field == null || props.db_field === undefined) {
                        return this.modelValue;
                    }
                    this.fields = props.db_field.join(',');

                    axios
                        .get(this.$store.state.mainurl+'//dataset/list?f=' + props.dataset_id + '&iDisplayStart=0&iDisplayLength=1&s_fields=' + this.fields + '&f_id=' + this.modelValue)
                        .then((response) => {
                            this.responseClassify=JSON.parse(response);
                                                            //console.log('update output',response.data.aaData);
                        })
                        .catch(error => console.log(error));

                    if (this.responseClassify.aaData === undefined || this.responseClassify.aaData.length != 1) {
                        return 'id:' + this.modelValue;
                    }
                        //			let resstr = '';
                    this.v = '';
                    for (var i = 0; i < props.db_field.length; i++) {
                        if (props.db_field[i] in this.responseClassify.aaData[0] && this.responseClassify.aaData[0][props.db_field[i]] != undefined && this.responseClassify.aaData[0][props.db_field[i]] != ''){
                        //					resstr += this.responseClassify.aaData[0][props.db_field[i]] + ' ';
                            this.v+= this.responseClassify.aaData[0][props.db_field[i]] + ' ';
                        
                            this.vid = this.modelValue;
                            this.searchvalue = {"value":this.vid, "title": this.v};
                            this.search = this.v;
                            this.options = [{"value":this.vid, "title": this.v}];

                        }
                    }

                }
            }    
        }    

        else if (this.modelValue=={id: null, name: null} || this.modelValue==''){
                // this.modelValue == undefined or ''
                this.v = '';
                this.vid = 0;
                this.searchvalue = {"value":this.vid, "title": this.v};
                this.search = this.v;
                this.options = [{"value":this.vid, "title": this.v}];

        }
        else {
//            console.log('classify', this.modelValue);
            this.v = '';
                this.vid = 0;
                this.searchvalue = {"value":this.vid, "title": this.v};
                this.search = this.v;
                this.options = [{"value":this.vid, "title": this.v}];



        }

    },


    methods:{


getFilterGroup() {
 let props = toRaw(this.column.widget.properties.filter);
if(props.mgroup!=undefined){
    this.groupFilter = '&f_'+Object.keys(props)[0]+'='+Object.values(props)[0];
}
// дико кривая фильтрация (привязана к названию поля и фильтрует только таксоны в образце) - разобраться и сделать как у Романа в компоненте Classify


},



        
        handleInput () {   
if (this.searchvalue == null) {
    this.$emit('update:modelValue', {id:null, name:''});
return;
}
else {
this.$emit('update:modelValue', {id:this.searchvalue.value, name:this.searchvalue.title});

// но ведь эмитить надо только ИД?

//this.modelValue.linkid - -где-то его же тоже надо эмитить?

// т.к. мы обновляем modelValue, то и эмитить надо свойства у modelValue (id, name) а не searchvalue (value, title) который является внутренним элементом v-autocomplite  
 //      this.$emit('update:modelValue', this.searchvalue.value, this.searchvalue.title);// здесь надо отдавать И ид И титл - тогда будет все ок в детайлсе.

     this.options = [{"value":this.searchvalue.value, "title":this.searchvalue.title}];
}


        },


        getLookupData(){
            this.getFilterGroup();
       //     let dataset_uri = '/dataset/list?f='+this.column.widget.properties.dataset_id;
            let dataset_uri = this.$store.state.mainurl+'/dataset/list?f='+this.column.widget.properties.dataset_id;

            let filtervalue = '&f_'+this.column.widget.properties.db_field+'='+this.search;

 //           let filtervalue = '&f_'+this.column.widget.properties.db_field+'='+"KAND";
            axios
                .post(dataset_uri+'&count_rows=true&iDisplayStart='+0+'&iDisplayLength='+10+this.groupFilter+filtervalue)

            //    .post(dataset_uri+'&iDisplayStart='+0+'&iDisplayLength=10&s_fields='+this.fields+this.groupFilter+filtervalue)

                .then((response) => {
                    let rows = response.data.aaData;
                    let rowsoptions=[];
                    if (this.column.title == 'Species') {
    // по другому ветвиться (без првязки к названию поля)
                        rows.forEach(function(item) {
                            let rowsitem={};
                            if(item.refmainsynonym.id != null){
                                rowsitem={"value":item.refmainsynonym.id, "title": item.name}
                            }
                            else {
                                rowsitem={"value":item.id, "title": item.name}
                            }
                            rowsoptions.push(rowsitem);
                        });
                    }
                    else {
                        rows.forEach(function(item) {
                            let rowsitem={};
                                rowsitem={"value":item.id, "title": item.name}
                            rowsoptions.push(rowsitem);
                        });
                    }
                        this.options = rowsoptions;
                    })
                .catch(error => console.log(error));
        },


//         getsearchvalue() {

// this.searchvalue = [{"value":this.value, "title": this.title}];

// },
    //     clearInput(){
    //     this.options = [];
    // },


    },

    watch: {
        search() {

if (this.search.length < 3 ) {
//    if (this.modelValue == undefined ) {
            this.labelmessage = "type more";
            return;

//            this.searchvalue = {"value":this.modelValue.id, "title": this.modelValue.name};
// this.searchvalue = undefined;
            }

else if (this.search.length >= 3) {
            this.labelmessage = "";
//           this.searchvalue = this.search;
            this.getLookupData();
//            this.searchvalue = {"value":this.modelValue.id, "title": this.modelValue.name};
// this.searchvalue = undefined;
            }


        },

    //     modelValue() {
    //       this.searchvalue = {"value":1, "title": "tre"};
    // },
//     searchvalue() {
//  //       this.v = this.modelValue.name;
//         this.v = this.searchvalue.title;
//     },

},

//     computed: {

//         modelValue() {
//             let mv = '';
//             if(typeof this.modelValue =='object') {
//                 mv = {"id":this.modelValue.id, "name": this.modelValue.name};
//             }
//             else {
//                 mv = this.modelValue.id
//             }

//             return mv;

//             },

// //     modelValue() {

// //      let mv = {"value":this.searchvalue.value, "title": this.searchvalue.title};
// // console.log(mv, "test");
// //       return mv;
// //     }
//        },

}
</script>
